module.exports = __webpack_public_path__ + "img/36.20e1592f.jpg";